<ion-content class="garment-listing">
    <app-header [isParentPage]="false" [title]="'Web Customer Product Edit'"></app-header>
    <div class="loading-container" style="padding-top:15%;" *ngIf="!loading">
        <ion-spinner></ion-spinner>
    </div>
    <ng-container>
    <input type="hidden" />

    <ion-grid >
      <ion-row>
        <ion-col size="2">
          <b>Function</b>
        </ion-col>
        <ion-col size="2.5">
            <ion-select  interface="popover" class="inputCss" [(ngModel)]="selectedFunction">
            <ion-select-option value="update">Update</ion-select-option>
            <ion-select-option value="delete">Delete</ion-select-option>
          </ion-select>
        </ion-col>

      </ion-row>
 <ion-row>
   <ion-col size="2">
      <ion-row size="2">
          <b>Product Code</b>
        </ion-row >
        <ion-row size="2" style="margin-top:30px">
          <b>Web Customer Code</b>
        </ion-row >
         <ion-row size="2" style="margin-top:30px">
            <b>Departments</b>
          </ion-row>
    </ion-col>
    <ion-col >
          <ion-row size="2.5" style="width: 24.2%;">
            <ion-input  type="text" size="50" [(ngModel)] ="productCode" class="inputCss" disabled></ion-input>
           </ion-row>
           <ion-row size="2.5" style="width: 24.2%;margin-top: 10px;">
            <ion-input  type="text" size="50" [(ngModel)] ="customerCode" class="inputCss" disabled></ion-input>
           </ion-row>
            <ion-row style="margin-top: 10px;">
              <input
                type="checkbox"
                [(ngModel)]="selectAll"
                (change)="toggleAllDepartments()"
                style="margin-right: 10px"
              />
              <b> All</b>
             </ion-row>
             <ion-row>
              <b> Restrict By Departments</b>
              </ion-row>
          <ion-row size="5" style="margin-top:10px; margin-left:10px"*ngFor="let dept of customerDepts" >
            
                  <input
                  type="checkbox"
                  name="dept.departmentCode"
                  [value]="dept.departmentCode"
                  [(ngModel)]="dept.isSelected"
                  [ngModelOptions]="{ standalone: true }"
                  style="margin-right:10px"
                />
             ({{dept.departmentCode}})   {{ dept.description }}
          </ion-row >
      </ion-col>
  </ion-row>
      <ion-row>
        <ion-col size="5"></ion-col>
        <ion-col size="2">
            <ion-button expand="block" (click)="UpdateCustomerProduct()">Save to Database</ion-button>
        </ion-col>
        <ion-col size="5">
        
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>
</ion-content>
